import { ColumnType } from 'antd/es/table'
import { Typography } from 'antd'
import MaterialType from '../../../../types/api/material-type'
import Material from '../../../../types/api/material'
import MaterialsTable from '../components/materials-table'

export const columns: ColumnType<MaterialType>[] = [
    {
        dataIndex: 'name',
        width: 400,
        render(value) {
            return <Typography.Text style={{ fontSize: 14 }}>{value}</Typography.Text>
        },
        onCell() {
            return { style: { verticalAlign: 'top' } }
        },
    },
    {
        dataIndex: 'materials',
        render(v: Material[]) {
            if (!v?.length) {
                return null
            }

            return (
                <div>
                    <MaterialsTable materials={v} />
                </div>
            )
        },
    },
]

// interface SubTableProps {
//     columns: ColumnType<any>[]
//     dataSource: any[]
// }

// const SubTable: FC<SubTableProps> = memo(({ columns, dataSource }) => {
//     // TODO: тут рендереные таблице не обновляются, но если была скрыта, а потом появилась (поиск убрали) все рендеряться заного
//     return (
//         <ConfigProvider theme={{ algorithm: theme.compactAlgorithm }}>
//             <Table
//                 size={'small'}
//                 style={{ width: 'fit-content' }}
//                 columns={columns}
//                 dataSource={dataSource}
//                 pagination={false}
//                 rowKey={x => x.id}
//             />
//         </ConfigProvider>
//     )
// })

// export const columns: ColumnType<any>[] = [
//     {
//         dataIndex: 'name',
//         // title: 'Наименование',
//         width: 500,
//         render(value, record, index) {
//             return <Typography.Text style={{ fontSize: 14 }}>{value}</Typography.Text>
//         },
//         onCell() {
//             return { style: { verticalAlign: 'top' } }
//         },
//     },
//     {
//         dataIndex: 'subTable',
//         // title: 'По ширинам',
//         render(v, r) {
//             const { columns, dataSource } = r.subTable
//             return (
//                 <div>
//                     <SubTable columns={columns} dataSource={dataSource} />
//                 </div>
//             )
//         },
//     },
// ]
